<template>
  <div class="responsabile" v-loading="loading">
    <div class="top-block">
      <div class="resp-header">
        <div class="mail col-24">
          {{ $t("resp.label.mailInfo") }}
          <el-checkbox v-model="checkMail" :indeterminate="false" class="riva-header-checkbox" @change="mailConv"></el-checkbox>
        </div>
        <div class="search">
          <select-deleghe :searchFilter="searchFilter" :activateWatch="activateWatchSelect" @changeUser="changeUser"
                          @endLoading="endLoading"></select-deleghe>
        </div>
        <div class="action">
           
        </div>
      </div>
    </div>

    <el-table :data="presenze" :height="tableHeight" :empty-text="$t('resp.msg.noData')"
      class="custom-table">
      <el-table-column
        :label="$t('resp.label.employee')"
        min-width="150">

        <template slot-scope="scope">
          <div class="data-wrapper">
            {{ scope.row.nomex }} {{ scope.row.cognx }}
          </div>
        </template>

      </el-table-column>
      <el-table-column header-align="center" align="center"
                       :label="$t('resp.label.date')"
                       width="140">

        <template slot-scope="scope">
          <div class="data-wrapper">
            {{ scope.row.mese}}/{{ scope.row.anno}}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="descr"
        :label="$t('resp.label.status')"
        min-width="300">
      </el-table-column>

      <el-table-column
        width="160">

        <template slot-scope="scope" slot="header">
          <div class="icon-check">
            <el-button class="WEB-button WEB-button-primary" style="width: 120px !important; padding-left: 0px !important; padding-right: 0px !important;"
                   @click="opRapPresenze('C')">{{ $t('resp.btn.convalida') }}</el-button>
            <el-tooltip class="item" effect="dark" :content="$t('resp.msg.selectAllApp')" placement="top">
              <el-checkbox class="check" @change="checkConvalida" ></el-checkbox>
            </el-tooltip>
          </div>
        </template>

        <template slot-scope="scope">
          <div v-if="scope.row.stato === 'A'">
            <el-checkbox v-model="scope.row.checkConvalida" style="float: right; margin-right: 2px;"></el-checkbox>
          </div>
        </template>

      </el-table-column>
      <el-table-column
        width="160">

        <template slot-scope="scope" slot="header">
          <div class="icon-check">
            <el-button class="WEB-button WEB-button-primary" style="width: 120px !important; padding-left: 0px !important; padding-right: 0px !important;"
                   @click="opRapPresenze('A')">{{ $t('resp.btn.riapri') }}</el-button>
            <el-tooltip class="item" effect="dark" :content="$t('resp.msg.selectAllReop')" placement="top">
              <el-checkbox class="check" @change="checkRiapertura"></el-checkbox>
            </el-tooltip>
          </div>
        </template>

        <template slot-scope="scope">
          <div v-if="scope.row.stato === 'A' || scope.row.stato === 'C'">
            <el-checkbox v-model="scope.row.checkRiapertura" style="float: right; margin-right: 2px;"></el-checkbox>
          </div>
        </template>

      </el-table-column>
      <el-table-column
        width="160">

        <template slot-scope="scope" slot="header">
          <div class="icon-check">
            <el-button class="WEB-button WEB-button-primary" style="width: 120px !important; padding-left: 0px !important; padding-right: 0px !important;"
                   @click="stampaConv('all')">{{ $t('resp.btn.stampa') }}</el-button>
            <el-tooltip class="item" effect="dark" :content="$t('resp.msg.selectAllPrint')" placement="top">
              <el-checkbox class="check" @change="checkStampa"></el-checkbox>
            </el-tooltip>
          </div>
        </template>

        <template slot-scope="scope">
          <div >
            <el-checkbox v-model="scope.row.checkStampa" style="float: right; margin-right: 2px;"></el-checkbox>
          </div>
        </template>

      </el-table-column>

      <el-table-column
        width="50" header-align="center" align="center">

        <template slot-scope="scope">
          <div class="icon pointer">
            <icon name="riv-docx" scale="1.3" @click.native="stampaConv('row',scope.row)"></icon>
          </div>
        </template>

      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  import moment from 'moment'
  import SelectDeleghe from './selectDelghe.vue'

  export default {
    components: {SelectDeleghe},
    watch: {
      '$mq.resize': 'resize'
    },
    name: 'Responsabile',
    i18n: {
      messages: {
        it_IT: {
          resp: {
            msg: {
              abort: 'Operazione Annullata',
              confValidation: 'Sei sicuro di voler Convalidare i documenti selezionati?',
              confReopening: 'Sei sicuro di voler Riaprire i documenti selezionati?',
              noDocsSelConv: 'Nessun documento selezionato per la Convalida',
              noDocsSelReop: 'Nessun documento selezionato per la Riapertura',
              selectAllApp: 'Seleziona tutti i documenti da Approvare',
              selectAllReop: 'Seleziona tutti i documenti da Riaprire',
              selectAllPrint: 'Seleziona tutti i documenti da Stampare',
              noData: 'Nessun Documento trovato'
            },
            btn: {
              stampa: 'Stampa',
              riapri: 'Riapri',
              convalida: 'Convalida',
              abort: 'Annulla'
            },
            label: {
              employee: 'Dipendente',
              date: 'Data',
              status: 'Stato',
              mailInfo: 'Desidera ricevere una mail sulla disponibilità di Rapporti Presenze da convalidare?'
            }
          }
        },
        fr_FR: {
          resp: {
            msg: {
              abort: 'Operazione Annullata',
              confValidation: 'Êtes-vous sur de vouloir valider les documents selectionnées?',
              confReopening: 'Êtes-vous sur de vouloir reouvrir les documents selectionnées?',
              noDocsSelConv: 'Aucun document selectionné pour la validation',
              noDocsSelReop: 'Aucun document selectionné pour la reouverture',
              selectAllApp: 'Selectionner tous les documents à valider',
              selectAllReop: 'Selectionner tous les documents à reouvrir',
              selectAllPrint: 'Selectionner tous les documents à imprimer',
              noData: 'Aucun document trouvé'
            },
            btn: {
              stampa: 'Imprimer',
              riapri: 'Reouvrir',
              convalida: 'Validation',
              abort: 'Annuler'
            },
            label: {
              employee: 'Salarié',
              date: 'Date',
              status: 'Etat',
              mailInfo: 'Souhaitez vous recevoir une e-mail pour vous advertir de la disponibilité des Rapports de Presence à valider?'
            }
          }
        },
        es_ES: {
          resp: {
            msg: {
              abort: 'Operación cancelada',
              confValidation: '¿Está seguro de querer validar los documentos seleccionados?',
              confReopening: '¿Está seguro de querer reabrir los documentos seleccionados?',
              noDocsSelConv: 'Ningún documento seleccionado para validación',
              noDocsSelReop: 'Ningún documento seleccionado parar reabrir',
              selectAllApp: 'Seleccionar todos los documentos para aprobación',
              selectAllReop: 'Seleccionar todos los documentos para rechazar',
              selectAllPrint: 'Seleccionar todos los documentos para imprimir',
              noData: 'Sin informacion'
            },
            btn: {
              stampa: 'Imprimir',
              riapri: 'Reabrir',
              convalida: 'Validación',
              abort: 'Anular'
            },
            label: {
              employee: 'Empleado',
              date: 'Fecha',
              status: 'País',
              mailInfo: '¿Desea recibir un email sobre la disponibilidad de un informe de presencia para validar?'
            }
          }
        },
        de_DE: {
          resp: {
            msg: {
              abort: 'Auftrag wurde abgebrochen',
              confValidation: 'Sind Sie sicher, dass Sie die ausgewählten Dokumente bestätigen möchten?',
              confReopening: 'Sind Sie sicher, dass Sie die ausgewählten Dokumente wiederöffnen möchten?',
              noDocsSelConv: 'Keine Dokument wurde zum Bestätigen ausgewählt',
              noDocsSelReop: 'Keine Dokument wurde zum Wiederöffnung ausgewählt',
              selectAllApp: 'Alle Dokumente zum Bestätigen auswählen',
              selectAllReop: 'Alle Dokumente zum Wiederöffnen auswählen',
              selectAllPrint: 'Alle Dokumente zum Drucken auswählen',
              noData: 'Kein Dokument gefunden'
            },
            btn: {
              stampa: 'Drucken',
              riapri: 'Wiederöffnen',
              convalida: 'Bestätigung',
              abort: 'Abbrechnen'
            },
            label: {
              employee: 'Mitarbeiter',
              date: 'Datum',
              status: 'Land',
              mailInfo: 'Möchten Sie eine Email bekommen, wenn es Berichte zum Bestätigen gibt?'
            }
          }
        },
      }
    },
    data () {
      return {
        loading: false,
        searchFilter: {
          'employee': null,
          'currentEmployee': null,
          'data': '',
          'anno': '',
          'mese': '',
          'periodo': ''
        },
        presenze: [],
        checkAllConv: false,
        checkAllRiapertura: false,
        checkAllStampa: false,
        checkMail: false,
        activateWatchSelect: false,
        tableHeight: 0
      }
    },
    methods: {
      rapPresenze: function () {
        this.loading = true
        var obj = {
          params: {
            codFisc: this.searchFilter.employee === null ? undefined : this.searchFilter.employee.valore
          }
        }
        this.$http.get('presenze/' + this.$store.state.country + '/rapportini', obj).then(response => {
          if (response.body.rc === 0) {
            this.presenze = response.body.data.map(function (obj) {
              obj.checkConvalida = false
              obj.checkRiapertura = false
              obj.checkStampa = false
              return obj
            })
            this.checkMail = response.body.attrib.avvisoMail === 'NO' ? false : true
            this.presenze = response.body.data
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
          this.loading = false
        })
      },
      opRapPresenze:function (op) {
        let _this = this;

        let message = "";
        let btnOK = "";
        if (op === 'A') {
          message = this.$i18n.t('resp.msg.confReopening');
          btnOK = this.$i18n.t('resp.btn.riapri');
        } else {
          message = this.$i18n.t('resp.msg.confValidation');
          btnOK = this.$i18n.t('resp.btn.convalida');
        }
        this.$confirm(message, 'Info', {
          confirmButtonText: btnOK,
          cancelButtonText: this.$i18n.t('resp.btn.abort'),
          type: 'info',
          callback: function(action) {
            if (action === 'confirm') {

              // RIAPERTURA   op = 'A'
              // CONVALIDA    op = 'C'

              let codFisc = _this.searchFilter.employee === null ? undefined : _this.searchFilter.employee.valore
              let counter = 0;
              //var op = 'A';
              //let righe = '[';
              //let riga = {}
              let righe = []
              let check = false;
              for (let i=0; i< _this.presenze.length; i++){
                check = (op === 'A' ? _this.presenze[i].checkRiapertura : _this.presenze[i].checkConvalida);
                if(check === true) {
                  counter++;
                  let riga = {
                    codFiscDip: _this.presenze[i].codFisc,
                    anno: _this.presenze[i].anno,
                    mese: _this.presenze[i].mese,
                    azione: op
                  }
                  righe.push(riga)
                  /*righe += '{' +
                   '"codFiscDip":"'+ _this.presenze[i].codFisc + '", ' +
                   '"anno":"'+ _this.presenze[i].anno +'", ' +
                   '"mese":"' + _this.presenze[i].mese + '", ' +
                   '"azione":"' + op + '"' +
                   '},';*/
                }
              }

              //if (righe.length > 1)
              //  righe = righe.slice(0, -1);
              //righe += ']';
              if(counter === 0) {
                _this.$message({
                  showClose: true,
                  message: op === 'C' ? _this.$i18n.t('resp.msg.noDocsSelConv') : _this.$i18n.t('resp.msg.noDocsSelReop'),
                  type: 'warning',
                  duration: process.env.duration
                })
              } else {
                _this.loading = true
                let obj = {
                  codFisc: codFisc,
                  mesi: righe
                }
                _this.$http.post('presenze/' + _this.$store.state.country + '/rapportini', obj).then(response => {
                  if (response.body.rc === 0) {
                    _this.$message({
                      showClose: true,
                      message: response.body.msg[0].msgTxt,
                      type: 'success',
                      duration: process.env.duration
                    })
                    _this.presenze = [];
                    _this.rapPresenze();
                  } else {
                    _this.$message({
                      showClose: true,
                      message: response.body.msg[0].msgTxt,
                      type: 'warning',
                      duration: process.env.duration
                    })
                  }
                  _this.loading = false
                })
              }
            } else {
              _this.$message({
                showClose: true,
                message: _this.$i18n.t('resp.msg.abort'),
                type: 'info',
                duration: process.env.duration
              })
            }
          }
        });
      },
      mailConv:function (event) {
        //this.loading = true
        let obj = {
          codFisc: this.searchFilter.employee === null ? undefined : this.searchFilter.employee.valore,
          avvisoMail: event ? "SI":"NO"
        }
        this.$http.post('presenze/' + this.$store.state.country + '/mailConv', obj).then(response => {
          if (response.body.rc === 0) {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'success',
              duration: process.env.duration
            })
          } else {
            this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'warning',
              duration: process.env.duration
            })
            this.checkMail = !event;
          }
          this.loading = false
        })
      },
      stampaConv: function (tipo, riga) {
        let counter = 0
        let righe = []
        if (tipo === 'row') {
          counter++
          let obj = {
            codFiscDip: riga.codFisc,
            anno: riga.anno,
            mese: riga.mese
          }
          righe.push(obj)
        } else {
          for (var i = 0; i < this.presenze.length; i++) {
            if (this.presenze[i].checkStampa === true) {
              counter++
              let obj = {
                codFiscDip: this.presenze[i].codFisc,
                anno: this.presenze[i].anno,
                mese: this.presenze[i].mese
              }
              righe.push(obj)
            }
          }
        }
        if (counter === 0) {
          this.$message({
            showClose: true,
            message: this.$i18n.t('resp.msg.abort'),
            type: 'warning',
            duration: process.env.duration
          })
        } else {

          var obj = {
            'righe': righe
          }
          this.$http.post('presenze/' + this.$store.state.country + '/presenzeConv', obj).then(response => {
            if (response.body.rc === 0) {
              let url = ('download/document?codLang=' + sessionStorage.getItem('codLang') + '&delete=SI'+
              '&fileName=' + response.body.data.file + '&filePath=anDipTmp' + '&token=' + sessionStorage.getItem('token'))
              console.log("URL: " + url)
              let win = window.open(process.env.baseUrlSpring + url, '_blank')
              win.focus()
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'warning',
                duration: process.env.duration
              })
            }
          })
        }
      },
      checkConvalida: function (event) {
        for (var i = 0; i < this.presenze.length; i++) {
          if (this.presenze[i].stato === 'A') this.presenze[i].checkConvalida = event
        }
      },
      checkRiapertura: function (event) {
        for (var i = 0; i < this.presenze.length; i++) {
          if (this.presenze[i].stato === 'A' || this.presenze[i].stato === 'C') this.presenze[i].checkRiapertura = event
        }
      },
      checkStampa: function (event) {
        for (var i = 0; i < this.presenze.length; i++) {
          this.presenze[i].checkStampa = event
        }
      },
      resize: function () {
        let contenitoreHeight = window.innerHeight - 140
        this.tableHeight = contenitoreHeight - 115
      },
      changeUser: function () {
        this.resize()
        this.rapPresenze()
      },
      endLoading: function () {
        this.resize()
        this.loading = false
      }
    },
    beforeMount: function () {
      this.loading = true
      //this.rapPresenze()
    }
  }
</script>


<style lang="less">
  @import "../../assets/less/general.less";

  .responsabile {
    height: 100%;
    min-width: 1250px;
    max-width: 100%;
    .top-block {
      background-color: white;
      width: 100%;
      z-index: 1;
      .resp-header {
        .set-font(@color: #606266; @size: 14px);
        //border: solid 1px darkgray;
        //margin: 15px 15px 15px 15px;
        //background-color: #f4f5f6;
        padding: 15px 19px 20px 19px;
        height: 95px;
        .mail {
          margin-bottom: 10px;
          padding: 0;
          text-align: left;
        }
        .search {
          padding: 0 !important;
          float: left;
          width: 430px;
          position: relative;
          .select {
            float: left;
            text-align: left;
            margin-right: 10px;
            .el-date-editor {
              width: 160px;
              .el-input__inner {
                border: none;
                border-bottom: 1px solid #e7e7e7;
                padding-right: 0;
                padding-left: 20px;
                height: 22px;
                line-height: 22px;
              }
              .el-input__prefix {
                line-height: 22px;
                left: -5px;
                .el-input__icon {
                  line-height: 22px;
                }
              }
              .el-input__suffix {
                line-height: 22px;
                //left: -5px;
                .el-input__icon {
                  line-height: 22px;
                }
              }
            }
          }
        }
        .status {
          position: relative;
          float: left;
          color: #606266;
        }
        .action {
            float: right;
            text-align: right;
        }
      }
      .table-header {
        .set-font(@size: 12px; @weight: bold);
        background-color: white;
        border-bottom: 1px solid @greenRiva;
        border-top: 1px solid @greenRiva;
        line-height: 38px;
        background-color: @white;
        text-align: left;
        //color: white;
        //margin-left: 15px;
        //margin-right: 15px;
        span {
          display: inline-block;
          text-align: center;
          //text-transform: uppercase;
        }
        .widthSelect {
          display: inline-block;
        }
      }
    }
    .el-table::before {
      height: 0px;
    }
    
    .el-checkbox {
      margin-bottom: 0px;
      margin-top: 10px;
      .el-checkbox__inner {
        border-radius: 0px;
      }
      &.is-checked {
        .el-checkbox__inner {
          background-color: @greenRiva;
          border-color: @greenRiva;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/PresenzeWeb/Responsabile.vue